import { createContext, useContext, useState, useCallback, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("epidemos-token"));
  const [loading, setLoading] = useState(true);

  const setAuth = useCallback((tokenVal, userData) => {
    setToken(tokenVal);
    setUser(userData);
    if (tokenVal) {
      localStorage.setItem("epidemos-token", tokenVal);
      axios.defaults.headers.common["Authorization"] = `Bearer ${tokenVal}`;
    } else {
      localStorage.removeItem("epidemos-token");
      delete axios.defaults.headers.common["Authorization"];
    }
  }, []);

  // Zaladuj usera z tokena
  useEffect(() => {
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      axios.get(`${API}/auth/me`)
        .then(res => { setUser(res.data); setLoading(false); })
        .catch(() => { setAuth(null, null); setLoading(false); });
    } else {
      setLoading(false);
    }
  }, [token, setAuth]);

  const register = async (identifier, password, role = "advertiser", ref_code = "") => {
    const res = await axios.post(`${API}/auth/register`, { identifier, password, role, ref_code });
    setAuth(res.data.token, res.data.user);
    return res.data;
  };

  const login = async (identifier, password) => {
    const res = await axios.post(`${API}/auth/login`, { identifier, password });
    setAuth(res.data.token, res.data.user);
    return res.data;
  };

  const logout = () => setAuth(null, null);

  const updateProfile = async (data) => {
    const res = await axios.put(`${API}/auth/profile`, data);
    setUser(res.data);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, register, login, logout, updateProfile, isLoggedIn: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be inside AuthProvider");
  return context;
}
